// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"f77b9838","769":"2047e449"}[chunkId] + ".chunk.js";
};